import { MoreOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Radio,
  Space,
  Dropdown,
  Menu,
  Popconfirm,
  Spin,
} from "antd";
import axios from "axios";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { CardBody, Media } from "reactstrap";
import { H4, H6, Image, P } from "../../../AbstractElements";
import { ProjectFileApi } from "../../../api";
import {
  deleteFile,
  fetchFileDetails,
  verifyFileName,
} from "../../../api/file.api";
import errorImg from "../../../assets/images/search-not-found.png";
import { LogEvents, LoggerContext } from "../../../context/logging";
import { getFormattedDate } from "../../../utils/DateFunctions/dateFormatter";
import { fileManagerCreationAndEditGranted } from "../../../utils/PermissionFunctions/userPermissions";
import { Loader } from "../../Loader";

import { getEllipsesFromText } from "../../../utils/StringFunctions/nameFormatter";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const FileContent = (props) => {
  const logger = useContext(LoggerContext);

  const [selectedFile, setSelectedFile] = useState(null);
  const [editNameIndex, setEditNameIndex] = useState(null);
  const [fileName, setFileName] = useState(null);

  const [currentFileVersions, setCurrentFileVersions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [versionModalVisible, setVersionModalVisible] = useState(false);
  const [documentUploadType, setDocumentUploadType] = useState("version");
  const [myfile, setMyFile] = useState([]);
  const [duplicateFileNameModal, setDuplicateFileNameModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [visible, setVisible] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [documentAdding, setDocumentAdding] = useState(false);
  const [documentEditing, setDocumentEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  const formRef = useRef();
  const fileInputRef = React.useRef(null);

  useEffect(() => {
    fetchFiles({ project: props.settings?.project?.id });
    logger.log(LogEvents.projectFiles, {});
  }, []);
  const fetchFiles = (params = {}) => {
    setLoading(true);
    axios
      .get(ProjectFileApi, { params: { ...params } })
      .then((response) => {
        setMyFile(response.data);
      })
      .finally(() => setLoading(false));
  };
  const handleChange = (event) => {
    event.preventDefault();
    setSearchTerm(event.target.value);
  };

  const getFileIcon = (url) => {
    var splittedUrl = url?.split("/");
    if (splittedUrl?.length) {
      var fileName = splittedUrl[splittedUrl?.length - 1];
      var extension = fileName.split(".")[1];
      if (extension) {
        if (
          extension === "png" ||
          extension === "jpg" ||
          extension === "svg" ||
          extension === "jpeg"
        ) {
          return "fa fa-file-image-o txt-primary";
        } else if (extension === "pdf") {
          return "fa fa-file-pdf-o txt-danger";
        } else if (extension === "xls" || extension === "xlsx") {
          return "fa fa-file-excel-o txt-success";
        } else if (extension === "zip") {
          return "fa fa-file-archive-o txt-secondary";
        } else {
          return "fa fa-file-text-o txt-info";
        }
      }
    }
  };

  const getFileName = (url) => {
    var splittedUrl = url?.split("/");
    var fileName = splittedUrl[splittedUrl.length - 1];
    if (fileName?.length > 20) {
      return fileName?.substring(0, 20) + "...";
    }
    return fileName;
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <div
              onClick={() => {
                setVisible(true);
                setTimeout(() => {
                  formRef?.current?.setFieldsValue({
                    file_name: selectedFile?.file_name,
                  });
                }, 300);
              }}
            >
              Edit
            </div>
          ),
        },
        {
          key: "2",
          label: (
            <div
              onClick={() => {
                setVersionModalVisible(true);
              }}
            >
              Manage versions
            </div>
          ),
        },
        {
          key: "3",
          label: (
            <div style={{ width: "100%" }}>
              <Popconfirm
                style={{ width: "100%" }}
                okText={"Yes"}
                cancelText={"No"}
                title={"Are you sure you want to delete this document?"}
                onConfirm={() => {
                  deleteFile({ id: selectedFile?.id }).then((res) => {
                    toast.success("File Deleted Successfully !");
                    fetchFiles({ project: props.settings?.project?.id });
                  });
                }}
              >
                <Button className="btn" size="small" danger>
                  Delete
                </Button>
              </Popconfirm>
            </div>
          ),
        },
      ]}
    />
  );

  const editFileName = () => {
    const updatedValues = formRef.current.getFieldsValue();
    console.log("updatedValues", updatedValues);
    setDocumentEditing(true);
    axios
      .put(ProjectFileApi + selectedFile?.id + "/", {
        file_name: updatedValues?.file_name,
      })
      .then((response) => {
        fetchFiles({ project: props.settings?.project?.id });
      })
      .catch((error) => {
        toast.error("Error while editing file name");
      })
      .finally(() => {
        setDocumentEditing(false);
        setVisible(false);
      });
  };

  const renameFile = (file_id) => {
    setDocumentEditing(true);
    setEditNameIndex(null);
    axios
      .put(ProjectFileApi + file_id + "/", {
        file_name: fileName,
      })
      .then((response) => {
        fetchFiles({ project: props.settings?.project?.id });
        toast.success("Successfully edited file.");
      })
      .catch((error) => {
        toast.error("Error while editing file name");
      })
      .finally(() => {
        setDocumentEditing(false);
        setVisible(false);
      });
  };
  // eslint-disable-next-line
  const filelist = myfile.map((data, i) => {
    return (
      <Col sm={6} style={{ marginBottom: 8, cursor: "pointer" }}>
        <Card
          key={i}
          onClick={() => {
            openInNewTab(data?.file);
          }}
          bodyStyle={{
            padding: 8,
          }}
          style={{ borderColor: "#CCCED0" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 12,
            }}
          >
            <i className={getFileIcon(data?.file)} style={{ fontSize: 32 }}></i>
            <Col
              className="d-flex justify-content-end"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <Dropdown
                overlay={menu}
                placement="bottomRight"
                onVisibleChange={() => {
                  setSelectedFile(data);
                  fetchFileDetails({ id: data.id }).then((res) => {
                    setCurrentFileVersions(res.version);
                  });
                }}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <MoreOutlined style={{ fontSize: 20 }} />
              </Dropdown>
            </Col>
          </div>
          <div className="file-bottom px-2 py-2">
            {editNameIndex == i ? (
              <>
                <Input
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      renameFile(data?.id);
                    }
                  }}
                  placeholder="File name"
                  defaultValue={data?.file_name}
                  onChange={(e) => {
                    setFileName(e.target.value);
                  }}
                />
                {/* <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  Save
                </Button> */}
              </>
            ) : (
              <div
                style={{
                  fontSize: 18,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setEditNameIndex(i);
                  setFileName(data?.file_name);
                }}
              >
                {getEllipsesFromText({ text: data?.file_name, length: 16 })}{" "}
              </div>
            )}
            <div>{data?.file_size}</div>
            <div>{getFormattedDate(data?.modified_at)}</div>
            {/* <P>
            <span>{"last open"} : </span>
            {data?.modify}
          </P> */}
          </div>
        </Card>
      </Col>
    );
  });
  const getFile = () => {
    document.getElementById("upfile").click();
  };

  const getFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["B", "KB", "MB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(parseFloat(bytes / Math.pow(k, i))) + " " + sizes[i];
  };

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const onFileUpload = () => {
    // showMessage('loading', 'Editing files...', 'upload-powo-files');
    let file = fileInput;
    // .map(y => (y.name = y.name.replace(/([^a-z0-9 ]+)/gi, '-')));
    console.log("FILE!", file);
    Object.keys(file).map((key) => {
      console.log("KK", key, file[key]);
      const formData = new FormData();
      formData.append("file", file[key]?.originFileObj, file[key].name);
      formData.append("project", props.settings?.project?.id);
      formData.append("file_size", getFileSize(file[key]?.originFileObj?.size));
      axios
        .post(ProjectFileApi, formData)
        .then((res) => {
          fetchFiles({ project: props.settings?.project?.id });
          toast.success("File Upload Successfully !");
          formRef.current.resetFields();
          setVisible(false);
          setFileInput(null);
        })
        .catch(() => {
          toast.error("Something went wrong!");
        });
    });

    // if (fileInput !== null) {
    // } else {
    //   toast.error("Plese Select at least one file !");
    // }
  };

  const onDocumentAdd = async (file) => {
    try {
      setDocumentAdding(true);
      const result = await Promise.all(
        Object.keys(file).map((key) => {
          console.log("KK", key);
          setSelectedDocument(file[key]);
          return verifyFileName({
            params: {
              file_name: file[key].name,
              project_id: props.settings?.project?.id,
            },
          })
            .then((res) => {
              if (res) {
                setDuplicateFileNameModal(true);
              } else {
                createNewFileVersion(file[key]);
              }
            })
            .catch((error) => {
              toast.error("Something went wrong please try again later!");
            });
        })
      );
    } catch (e) {
      console.log("i-log> ", e);
    } finally {
      setDocumentAdding(false);
    }
  };

  const createNewFileVersion = async (file) => {
    try {
      console.log("file", file);
      setDuplicateFileNameModal(false);
      const formData = new FormData();
      formData.append("file", file, file?.name);
      formData.append("file_name", file?.name);
      formData.append("project", props.settings?.project?.id);
      formData.append("file_size", getFileSize(file?.size));
      return axios
        .post(ProjectFileApi, formData)
        .then((res) => {
          fetchFiles({ project: props.settings?.project?.id });
          toast.success("Files Upload Successfully !");
          fileInputRef.current.value = "";
        })
        .catch((e) => {
          console.log("e", { e });
          toast.error("Something went wrong please try again later!");
          fileInputRef.current.value = "";
        });
    } catch (e) {
      console.log("i-log> ", e);
    }
  };

  const createDuplicateFile = async (file) => {
    try {
      console.log("file", file);
      setDuplicateFileNameModal(false);
      const formData = new FormData();
      formData.append("file", file, file?.name);
      formData.append("file_name", file?.name);
      formData.append("project", props.settings?.project?.id);
      formData.append("duplicate", true);
      formData.append("file_size", getFileSize(file?.size));
      return axios
        .post(ProjectFileApi, formData)
        .then((res) => {
          fetchFiles({ project: props.settings?.project?.id });
          toast.success("Files Upload Successfully !");
          fileInputRef.current.value = "";
        })
        .catch((e) => {
          console.log("e", { e });
          toast.error("Something went wrong please try again later!");
          fileInputRef.current.value = "";
        });
    } catch (e) {
      console.log("i-log> ", e);
    }
  };

  const selectDocumentUploadType = (e) => {
    setDocumentUploadType(e.target.value);
  };
  return (
    <Fragment>
      <CardBody>
        <Media>
          <H4>File Manager</H4>
          <Media body className="text-end">
            <input
              type="file"
              id="file"
              multiple
              onChange={(e) => {
                console.log(e.target);
                console.log(e.target.files);
                onDocumentAdd(e.target.files);
              }}
              ref={fileInputRef}
              style={{ width: 1, height: 1, opacity: 0, overflow: "hidden" }}
            />
            {fileManagerCreationAndEditGranted(props.settings?.user) && (
              <div
                className="btn btn-primary ms-2"
                onClick={
                  () => {
                    fileInputRef.current?.click();
                  }
                  // setVisible(true)
                }
              >
                <span>{"Upload"}</span>
              </div>
            )}
          </Media>
        </Media>
        {loading ? (
          <Loader />
        ) : filelist.length ? (
          <Row gutter={8} style={{ padding: 8 }}>
            {documentAdding && (
              <Col sm={6}>
                <Card bodyStyle={{ padding: 8 }}>
                  <Spin size="large" />
                </Card>
              </Col>
            )}
            {filelist}
          </Row>
        ) : (
          <Image
            attrImage={{
              className: "img-fluid m-auto",
              src: errorImg,
              alt: "",
            }}
          />
        )}
        <Drawer
          title="Upload File"
          width={500}
          onClose={() => {
            setVisible(false);
          }}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button
                onClick={() => {
                  setVisible(false);
                }}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn-primary"
                form="uploadForm"
                type="primary"
                htmlType="submit"
              >
                Submit
              </Button>
            </div>
          }
        >
          <Form
            ref={formRef}
            layout="vertical"
            id="uploadForm"
            onFinish={editFileName}
            disabled={documentEditing}
          >
            <Form.Item
              name={"file_name"}
              label="File name"
              rules={[
                {
                  required: true,
                  message: "Name is required",
                },
              ]}
            >
              <Input placeholder="File name" />

              {/* <Upload
                {...{ multiple: true, maxCount: 5 }}
                beforeUpload={() => false}
                onChange={({ file, fileList }) => {
                  console.log(file, fileList);
                  setFileInput(fileList);
                }}
                style={{ width: "100%" }}
              >
                <Button block type="dashed" icon={<UploadOutlined />}>
                  Upload
                </Button>
              </Upload> */}
            </Form.Item>
          </Form>
        </Drawer>
      </CardBody>

      <Modal
        title="Upload options"
        centered
        visible={duplicateFileNameModal}
        onOk={() => {
          if (documentUploadType == "version") {
            createNewFileVersion(selectedDocument);
          } else {
            createDuplicateFile(selectedDocument);
          }
        }}
        okText="Upload"
        onCancel={() => setDuplicateFileNameModal(false)}
        width={"40%"}
        className="no-budget-item-modal-style"
      >
        <Col className="p-2 px-4">
          <Col className="py-2">
            {selectedDocument?.name} already exists in this location. Do you
            want to update the existing file with a new version or keep both
            files? Replacing the file won't change sharing settings.
          </Col>

          <Radio.Group
            onChange={selectDocumentUploadType}
            value={documentUploadType}
          >
            <Space direction="vertical">
              <Radio value={"version"}>Update existing file</Radio>
              <Radio value={"duplicate"}>Keep both files</Radio>
            </Space>
          </Radio.Group>
        </Col>
      </Modal>

      <Drawer
        title="Manage versions"
        width={500}
        onClose={() => {
          setVersionModalVisible(false);
        }}
        visible={versionModalVisible}
      >
        <>
          <Col>
            <h6>{selectedFile?.file_name}</h6>
          </Col>
          <Col style={{ marginBottom: 8, cursor: "pointer" }}>
            <Card
              key={"v1"}
              onClick={() => {
                openInNewTab(selectedFile?.file);
              }}
              bodyStyle={{
                padding: 0,
              }}
              style={{ borderColor: "#CCCED0" }}
            >
              <Row className="file-bottom px-2 py-2">
                <Col sm={18}>
                  <div className="f-16">
                    Current version {""}{" "}
                    <small class="text-muted">
                      {"   "}
                      {getEllipsesFromText({
                        text: selectedFile?.file_name,
                        length: 28,
                      })}
                    </small>
                  </div>
                  <div className="f-14" class="text-muted">
                    {selectedFile?.file_size}
                  </div>
                  <div className="f-14" class="text-muted">
                    {getFormattedDate(selectedFile?.modified_at)}
                  </div>
                </Col>
                <Col sm={6}>
                  <Row justify="end" align="center">
                    <i
                      className={getFileIcon(selectedFile?.file)}
                      style={{ fontSize: 32 }}
                    ></i>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>

          {currentFileVersions?.map((version, i) => {
            return (
              <Col style={{ marginBottom: 8, cursor: "pointer" }}>
                <Card
                  key={i}
                  onClick={() => {
                    openInNewTab(version?.file);
                  }}
                  bodyStyle={{
                    padding: 0,
                  }}
                  style={{ borderColor: "#CCCED0" }}
                >
                  <Row className="file-bottom px-2 py-2">
                    <Col
                      sm={18}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className="f-16">
                        Version {currentFileVersions?.length - i}
                        <small class="text-muted">
                          {"   "}{" "}
                          {getEllipsesFromText({
                            text: version?.file_name,
                            length: 16,
                          })}
                        </small>
                      </div>
                      <div className="f-14" class="text-muted">
                        {version?.file_size}
                      </div>
                      <div className="f-14" class="text-muted">
                        {getFormattedDate(version?.modified_at)}
                      </div>

                      <Popconfirm
                        style={{ width: "100%" }}
                        okText={"Yes"}
                        cancelText={"No"}
                        title={"Are you sure you want to delete this version?"}
                        onConfirm={() => {
                          deleteFile({ id: version?.id }).then((res) => {
                            fetchFiles({
                              project: props.settings?.project?.id,
                            });
                            fetchFileDetails({ id: selectedFile?.id }).then(
                              (res) => {
                                setCurrentFileVersions(res.version);

                                toast.success("File Deleted Successfully !");
                              }
                            );
                          });
                        }}
                      >
                        <Button className="btn" size="small" danger>
                          Delete
                        </Button>
                      </Popconfirm>
                    </Col>
                    <Col sm={6}>
                      <Row className="h-100" justify="end" align="center">
                        <i
                          className={getFileIcon(version?.file)}
                          style={{ fontSize: 32 }}
                        ></i>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })}
        </>
      </Drawer>
    </Fragment>
  );
};
export default connect(mapStateToProps)(FileContent);
